
import React, { useState, useEffect } from 'react';

interface FaitImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: string;
  imageContext?: 'cholent' | 'kugel' | 'kishke' | 'crowd' | 'interior' | 'meat' | 'drinks' | 'general';
}

// Fallback dictionary based on context - serving as backup if local images fail
const FALLBACKS = {
  cholent: 'https://images.unsplash.com/photo-1547592180-85f173990554?q=80&w=2070&auto=format&fit=crop', 
  kugel: 'https://images.unsplash.com/photo-1619861298685-6d0932287b41?q=80&w=2070', 
  kishke: 'https://images.unsplash.com/photo-1529042410759-befb1204b468?q=80&w=1972', 
  crowd: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=2070', 
  interior: 'https://images.unsplash.com/photo-1559339352-11d035aa65de?q=80&w=1974', 
  meat: 'https://images.unsplash.com/photo-1532336414038-cf19250c5757?q=80&w=2070', 
  drinks: 'https://images.unsplash.com/photo-1622483767028-3f66f32aef97?q=80&w=2070', 
  general: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?q=80&w=2070', 
};

const FaitImage: React.FC<FaitImageProps> = ({ src, alt, className, fallbackSrc, imageContext = 'general', ...props }) => {
  const [imgSrc, setImgSrc] = useState<string | undefined>(undefined);

  useEffect(() => {
    // 1. Guard Clause: Check for empty string
    if (!src || (typeof src === 'string' && src.trim() === '')) {
        const fallback = fallbackSrc || FALLBACKS[imageContext] || FALLBACKS.general;
        setImgSrc(fallback);
        return;
    }
    
    setImgSrc(src as string);
  }, [src, fallbackSrc, imageContext]);

  const handleError = () => {
     // Switch to fallback silently on error
      const newSrc = fallbackSrc || FALLBACKS[imageContext] || FALLBACKS.general;
      // Prevent infinite loop if fallback also fails
      if (imgSrc !== newSrc) {
          setImgSrc(newSrc);
      }
  };

  return (
    <img
      {...props}
      src={imgSrc}
      alt={alt}
      onError={handleError}
      className={`${className} transition-opacity duration-500`}
    />
  );
};

export default FaitImage;
